import { ComponentPropsWithoutRef, FC } from 'react';

type CaretRightProps = ComponentPropsWithoutRef<'svg'>;

export const CaretRightIcon: FC<CaretRightProps> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path d="M6.27539 11.369V4.63184L9.64395 8.0004L6.27539 11.369Z" fill={fill ?? 'currentColor'} />
        </svg>
    );
};
